
import React, {useState, useEffect, useContext,useRef} from "react";
import {useHistory,useParams} from "react-router-dom";
import classNames from "classnames";
import sha1 from "sha1";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";


import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";
import { UserLoginContext } from "../../context/UserLoginContext";
import { EventsContext } from "../../context/EventsContext";

const EventsTable = () => {
    //Grab the event ID!
    const [eventsState, setEventsState] = useContext(EventsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const history = useHistory();
    const [data, setData] = React.useState([]);
    const notificationAlertRef = useRef(null);

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    // Update table data whenever events change
    useEffect(() => {
        if (userState.status && eventsState.theEvents && Array.isArray(eventsState.theEvents)) {
            const tableData = eventsState.theEvents.map((theEvent, i) => {
                return {
                    id: theEvent._id,
                    Title: theEvent.Title,
                    SubTitle: theEvent.SubTitle,
                    Type: theEvent.Type,
                    MaxRegistrations: theEvent.MaxRegistrations,
                    Registrations: theEvent.Registrations?.length || 0,
                    Status: (theEvent.Enabled) ? "Activated" : "Not Activated",

                    actions: (
                        // we've added some custom button actions
                        <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Event</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setEventsState((preveventsState) => ({
                                            ...preveventsState,
                                            theEvent: theEvent}));
                                        let tURL = "/admin/editevent/" + theEvent._id;
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to remove the data row */}
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Event</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        const eventIndex = eventsState.theEvents.findIndex(e => e._id === theEvent._id);
                                        if (eventIndex !== -1) {
                                            _deleteEventAlert(theEvent._id, eventsState.theEvents, eventIndex);
                                        }
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"addregistration_" + i}>Add a Registration</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        // Lets load all the registrations for this event into the context
                                        let tempURL = rest.events + '/' + theEvent._id;
                                        const eventResponse = await authenticatedFetch(tempURL, {
                                            method: 'GET'
                                        });
                                        const eventData = await eventResponse.json();
                                        setEventsState((preveventsState) => ({
                                            ...preveventsState,
                                            theEvent: eventData
                                        }));
                                        let tURL = "/admin/addregistration/" + theEvent._id;
                                        await history.push(tURL);
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-badge"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"editregistrations_" + i}>Edit Registrations</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        //Lets load all the registrations for this event into the context
                                        let tempURL = rest.events + '/' + theEvent._id;
                                        const eventResponse = await authenticatedFetch(tempURL, {
                                            method: 'GET'
                                        });
                                        const eventData = await eventResponse.json();
                                        setEventsState((preveventsState) => ({
                                            ...preveventsState,
                                            theEvent: eventData
                                        }));
                                        let tURL = "/admin/editregistrations/" + theEvent._id;
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-vector"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [eventsState.theEvents, userState.status]);

    useEffect(() => {
        const getEvents = async () => {
            try {
                let tempURL = rest.events;
                const eventsList = await authenticatedFetch(tempURL, {
                    method: 'GET'
                });

                if (!eventsList.ok) {
                    console.error('Failed to fetch events:', eventsList.status);
                    return;
                }

                const eventsData = await eventsList.json();
                setEventsState((preveventsState) => ({
                    ...preveventsState,
                    theEvents: eventsData
                }));
            } catch (error) {
                console.error('Error fetching events:', error);
            }
        };

        if (userState.status) {
            getEvents();
        }
    }, [userState.status]);

    const _delete_event = async (id) => {
        try {
            const timestamp = Date.now();
            const api_key = userState.apiKeyCloudinary;
            const api_secret = userState.apiSecretKeyCloudinary;
            const cloudURL = userState.cloudinary_destory;

            // Fetch the event to get the image public ID
            let tempURL = rest.events + '/' + id;
            const eventResponse = await authenticatedFetch(tempURL, {
                method: 'GET'
            });

            if (!eventResponse.ok) {
                throw new Error('Failed to fetch event details');
            }

            const eventData = await eventResponse.json();
            const eventPublicID = eventData.ImagePublicId;

            // Delete the event from the database
            tempURL = rest.events + '/' + id;
            const deleteResponse = await authenticatedFetch(tempURL, {
                method: 'DELETE'
            });

            if (!deleteResponse.ok) {
                throw new Error('Failed to delete event');
            }

            // Delete the image from Cloudinary if it exists
            if (eventPublicID !== "") {
                let payload_to_sign = "public_id=" + eventPublicID + "&timestamp=" + timestamp + api_secret;
                let sha1_hash = sha1(payload_to_sign);

                await fetch(cloudURL, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        api_key: api_key,
                        public_id: eventPublicID,
                        signature: sha1_hash,
                        timestamp: timestamp
                    }),
                });
            }

            return { success: true };
        } catch (error) {
            console.error('Error deleting event:', error);
            return { success: false, error: error.message };
        }
    };

    const _deleteEventAlert = async (id,events,index) => {
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={async () => {
                    setalert(null);

                    // Delete the event
                    const result = await _delete_event(id);

                    if (result.success) {
                        // Use filter for immutable update - remove the deleted event
                        const updatedEvents = events.filter(event => event._id !== id);
                        setEventsState((preveventsState) => ({
                            ...preveventsState,
                            theEvents: updatedEvents
                        }));

                        notify("success", "Event has been deleted successfully!");
                    } else {
                        notify("danger", "Error deleting event: " + (result.error || "Unknown error"));
                    }
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to delete this event?
            </SweetAlert>
        );
    };
    if (userState.status) {
        return (
            <>
                <div className="react-notification-alert-container">
                    <NotificationAlert ref={notificationAlertRef} />
                </div>
                <div className="content">
                    <Col md={8} className="ml-auto mr-auto">
                        <h2 className="text-center">Manage Events</h2>
                        <p className="text-center">
                            Create and manage events with registration capabilities
                        </p>
                    </Col>
                    <Row className="mt-5">
                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <CardTitle tag="h4">Events</CardTitle>
                                        </Col>
                                        <Col md="6" className="text-right">
                                            <Button
                                                color="info"
                                                onClick={() => history.push("/admin/addevent")}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-simple-add"/> Add Event
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Sub Title",
                                                accessor: "SubTitle"
                                            },
                                            {
                                                Header: "Status",
                                                accessor: "Status"
                                            },
                                            {
                                                Header: "Type",
                                                accessor: "Type"
                                            },
                                            {
                                                Header: "Max Registrations",
                                                accessor: "MaxRegistrations"
                                            },
                                            {
                                                Header: "Registrations",
                                                accessor: "Registrations"
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {alert}
                </div>
            </>

        );
    }

    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};

export default EventsTable;
